import { Tag } from '@components/ui';
import dayjs from 'dayjs';
import React from 'react';
import { SelectedFiltersType } from 'src/pages/dashboard';

import styles from './ActiveFilters.module.scss';

interface TagsProps {
  appliedFilters: SelectedFiltersType;
  setAppliedFilters: React.Dispatch<React.SetStateAction<SelectedFiltersType>>;
}

export const ActiveFilters: React.FC<TagsProps> = ({ appliedFilters, setAppliedFilters }) => (
  <div className={styles.wrapper}>
    {appliedFilters.models.map(model => (
      <Tag
        key={model}
        label={model}
        onRemove={label =>
          setAppliedFilters({ ...appliedFilters, models: appliedFilters.models.filter(m => m !== label) })
        }
      />
    ))}
    {appliedFilters.useCases.map(useCase => (
      <Tag
        key={useCase}
        label={useCase}
        onRemove={label =>
          setAppliedFilters({ ...appliedFilters, useCases: appliedFilters.useCases.filter(uc => uc !== label) })
        }
      />
    ))}
    {appliedFilters.departments.map(department => (
      <Tag
        key={department}
        label={department}
        onRemove={label =>
          setAppliedFilters({ ...appliedFilters, departments: appliedFilters.departments.filter(d => d !== label) })
        }
      />
    ))}
    {!dayjs(appliedFilters.untilDate).isSame(new Date(), 'day') && (
      <Tag
        label={`up to ${dayjs(appliedFilters.untilDate).format('MMMM YYYY')}`}
        onRemove={() => setAppliedFilters({ ...appliedFilters, untilDate: new Date() })}
      />
    )}
    {(appliedFilters.departments?.length > 0 ||
      appliedFilters.useCases?.length > 0 ||
      appliedFilters.models?.length > 0 ||
      !dayjs(appliedFilters.untilDate).isSame(new Date(), 'day')) && (
      <div
        className={styles.clearFilters}
        onClick={() => setAppliedFilters({ departments: [], useCases: [], models: [], untilDate: new Date() })}
      >
        Clear all filters
      </div>
    )}
  </div>
);
